<script>
import axios from 'axios';

export default {
    name: 'SocialTracker',
    data() {
        return {
            loading: true,
            error: null
        };
    },
    async created() {
        await this.trackAdImpression();
    },
    methods: {
        async trackAdImpression() {
            try {
                const source = this.$route.query.source?.replace(/"/g, '') || 'facebook';
                const campaign = this.$route.query.campaign?.replace(/"/g, '') || '3';

                const ipRes = await axios.get('https://ipapi.co/json/');
                const userIp = ipRes?.data?.ip || '0.0.0.0';

                const apiURL = `https://us-central1-nestease-dev.cloudfunctions.net/widgets/open/adImpressions?source=${source}&campaign=${campaign}&userIp=${userIp}`;
                let response = await axios.get(apiURL);
                console.log("ddd", response)
                if (typeof response.data === 'string') {
                    window.location.href = response.data;
                }
            } catch (err) {
                this.error = err.message || 'Tracking failed';
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>
